import { shopifyProductField } from '@/core/contentfulConfig';
import { TypeProductFields } from '@/core/generated-types';
import { getProductById } from '../shopify';
import { getContentType } from '@/core/constants';
import { Entry, EntryCollection } from 'contentful';

const productFieldName = shopifyProductField();

async function appendShopifyProduct(entry: Entry<any>) {
  const contentType = getContentType(entry);
  if (contentType === 'product' && !entry.fields.shopifyProduct) {
    const productFields = entry.fields;
    const productId =
      productFields[productFieldName as keyof TypeProductFields];
    if (productId) {
      const shopifyProduct = await getProductById(productId);
      entry.fields.shopifyProduct = shopifyProduct;
    }
  }
}

async function checkNextLevel(entry: Entry<any>) {
  if (entry.fields) {
    for (const nestedEntry of Object.values(entry.fields as Entry<any>)) {
      await fetchShopifyProduct(nestedEntry);
    }
  }
  if (Array.isArray(entry)) {
    for (const nestedEntry of entry) {
      await fetchShopifyProduct(nestedEntry);
    }
  }
}

export async function fetchShopifyProduct(entry: Entry<any> | undefined) {
  if (!entry) return;

  await appendShopifyProduct(entry);
  await checkNextLevel(entry);
}

export default async function fetchShopifyProducts<T extends object>(
  entries: EntryCollection<T>,
) {
  const fetchPromises = entries.items.map((entry) =>
    fetchShopifyProduct(entry),
  );
  await Promise.all(fetchPromises);
  return entries;
}
